module.exports = __webpack_public_path__ + "img/arrival_8.40ff25bf.jpg";